const config = {
	domain: process.env.VUE_APP_DOMAIN,
	header: {
		headers: {
			'Content-Type': 'application/json',
			'Authorization': process.env.VUE_APP_AUTHORIZATION,
		}
	},
	headerFile: {
		headers: {
			'Content-Type': 'multipart/form-data',
			'Authorization': process.env.VUE_APP_AUTHORIZATION,
		}
	},
	aes: 'JEywAYGQGIIcxXSzlsRUzdxtiu_E84oygPo3ZiCvFjhbr_9mAA-vAOWr31bG',
};

module.exports = config;